export enum ThemeColor {
  BLUE,GREEN,ORANGE,PINK,PURPLE,YELLOW
}